import { Component } from "react";
import m from "@utils/strings";
import Button from "@material-ui/core/Button";
import Divider from "../../layout/Divider";
import Padder from "../../layout/Padder";
import styled from "@emotion/styled";

const theme = (type) => {
  switch (type) {
    case "success":
      return "#7BC72A";
    case "denied":
    case "error":
      return "#DF1F36";
    default:
      return "#9b9b9b";
  }
};

const Label = styled.label`
  color: ${(props) => theme(props.type)};
  font-family: "Work Sans";
  font-size: ${(props) => props.size || 16}px;
  margin-top: 15px;
  font-weight: 400;
  width: 100%;
`;

class AreaResultado extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown = (event) => {
    if (!this.props.show) return;
    if (event.key === "Enter") {
      event.preventDefault();
      this.props.onFinish?.();
    }
  };

  handleFinish = (event) => {
    this.props.onFinish?.();
  };

  render() {
    if (!this.props.show) return <></>;

    if (true) {
      return (
        <div className="area-resposta">
          <Label
            id="resultado-area-text"
            className="result-area-text-success"
            size={20}
            type={this.props.result.type}
          >
            {this.props.result.type == "success"
              ? m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_ATENDIMENTO_AUTORIZADO
              : this.props.result.type == "error"
              ? m.TELA_CONSULTA_ELETIVA.MENSAGEM_API_ERROR
              : m.TELA_CONSULTA_ELETIVA.MENSAGEM_BENEFICIARIO_NAO_ELEGIVEL}
          </Label>
          <Label>{this.props.result.message}</Label>
          <Padder size="md" />
          <Divider />
          <Padder size="lg" />
          <Button onClick={this.handleFinish} className="btn-form">
            {m.TELA_CONSULTA_ELETIVA.LABEL_NOVO_ATENDIMENTO} (ENTER)
          </Button>
        </div>
      );
    }
  }
}

export default AreaResultado;

export class Result {
  code;
  type;
  message;
}
